<mat-progress-bar class="progress-bar" mode="indeterminate" *ngIf="!show"></mat-progress-bar>
<viavi-table
  *ngIf="show && table && table.data?.length > 0"
  [tableConfigurations]="table"
  [isActionEnabled]="true"
  (sendSeletedItem)="sendSelectedItem($event)"
  [options]="options"
  [cartMode]="cartView"
></viavi-table>
<div *ngIf="!table || (table && table.data?.length === 0)" class="no-record">No records found</div>
